<template>
    <div class="content-wrapper">
        <section class="hero is-fullheight">
            <home-navigation></home-navigation>
            <hero-body></hero-body>
            <hero-footer></hero-footer>
        </section>
        <section class="section is-medium" id="about">
            <about-section></about-section>
        </section>
        <section class="features" id="story">
            <story-section></story-section>
        </section>
        <section class="section is-medium why" id="why">
            <why-unet></why-unet>
        </section>
        <section class="section is-small" id="company">
            <company-info></company-info>
        </section>
        <section class="features" id="faq">
            <features-section></features-section>
        </section>
        <section class="section is-small" id="offices">
            <offices-section></offices-section>
        </section>
        <footer class="footer">
            <div class="content has-text-centered">
                <a href="https://www.facebook.com/unetjapan" style="padding-right: 15px;">
                    <span class="icon has-text-black">
                        <i class="fab fa-facebook fa-2x"></i>
                    </span>
                </a>
                <a href="https://www.instagram.com/unet_japan">
                    <span class="icon has-text-black">
                        <i class="fab fa-instagram fa-2x"></i>
                    </span>
                </a>
                <p>© 2018, Unet.</p>
            </div>
        </footer>
    </div>
</template>

<script>
    import Navigation from './Navigation'
    import HeroBody from  './HeroBody'
    import HeroFooter from './HeroFooter'
    import About from './About'
    import Features from './Features'
    import Subscribe from './Subscribe'
    import Offices from './Offices'
    import WhyUnet from './WhyUnet.vue'
    import Story from './Story.vue'
    import CompanyInfo from './CompanyInfo.vue'
    export default {
        components: {
            homeNavigation: Navigation,
            heroBody: HeroBody,
            heroFooter: HeroFooter,
            aboutSection: About,
            featuresSection: Features,
            subscribeSection: Subscribe,
            officesSection: Offices,
            whyUnet: WhyUnet,
            storySection: Story,
            companyInfo: CompanyInfo
        }
    }
</script>

<style scoped>
    @import '../../assets/css/home.css';
    .hero {
        background: black url('../../assets/hero.jpg') center / cover;
    }
    .features {
        background: black url('../../assets/cargo.jpg');
        background-attachment: fixed;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .subscribe {
        background-color: rgba(105, 105, 105, 0.11);
    }
    .why {
        background-color: rgba(105, 105, 105, 0.11);
    }
    footer {
        height: 10px;
        padding: 2rem 1.5rem 3rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/Home/HomePage.vue